import {defineRouting} from 'next-intl/routing';
import {createNavigation} from 'next-intl/navigation';

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ['en', 'fr', 'ar', 'kab'],

  // Used when no locale matches
  defaultLocale: 'en',
  pathnames :{
    "/": "/",
    "/boutiquechohrateam":"/boutiquechohrateam",
    "/account/sale":"/account/sale",
    "/account/wishlist":"/account/wishlist",
    "/account/team-users":"/account/team-users",
    "/contact-us": {
      en: "/contact-us",
      fr: "/contact-us",
      ar: "/اتصل-بنا",
      kab: "/contact-us"
    },
    "/blog": {
      en: "/blog",
      fr: "/blog",
      ar: "/مدونة",
      kab: "/blog"
    },
    "/search": {
      en: "/search",
      fr: "/recherche",
      ar: "/بحث",
      kab: "/nadi"
    },
    "/account": {
      en: "/account",
      fr: "/compte",
      ar: "/الحساب",
      kab: "/amuddu"
    },
    "/account/create-post": {
      en: "/account/create-post",
      fr: "/compte/creer-article",
      ar: "/الحساب/إنشاء-منشور",
      kab: "/amuddu/rnu-amas"
    },
    "/account/edite-post": {
      en: "/account/edite-post",
      fr: "/compte/modifier-article",
      ar: "/الحساب/تعديل-منشور",
      kab: "/amuddu/ssenfel-amas"
    },
    "/account/create-product": {
      en: "/account/create-product",
      fr: "/compte/creer-produit",
      ar: "/الحساب/إنشاء-منتج",
      kab: "/amuddu/rnu-afaris"
    },
    "/account/edite-product": {
      en: "/account/edite-product",
      fr: "/compte/modifier-produit",
      ar: "/الحساب/تعديل-منتج",
      kab: "/amuddu/ssenfel-afaris"
    },
    "/account/view-post": {
      en: "/account/view-post",
      fr: "/compte/voir-article",
      ar: "/الحساب/عرض-المنشور",
      kab: "/amuddu/wali-amas"
    },
    "/account/view-product": {
      en: "/account/view-product",
      fr: "/compte/voir-produit",
      ar: "/الحساب/عرض-المنتج",
      kab: "/amuddu/wali-afaris"
    },
    "/account/orders": {
      en: "/account/orders",
      fr: "/compte/commandes",
      ar: "/الحساب/الطلبات",
      kab: "/amuddu/iberdan"
    },
    "/account/address": {
      en: "/account/address",
      fr: "/compte/adresse",
      ar: "/الحساب/العنوان",
      kab: "/amuddu/ansa"
    },
    "/account/feedback": {
      en: "/account/feedback",
      fr: "/compte/avis",
      ar: "/الحساب/التقييمات",
      kab: "/amuddu/azen"
    },
    "/account/informations": {
      en: "/account/informations",
      fr: "/compte/informations",
      ar: "/الحساب/المعلومات",
      kab: "/amuddu/informations"
    },
    "/account/indexnow": {
      en: "/account/indexnow",
      fr: "/compte/indexnow",
      ar: "/الحساب/indexnow",
      kab: "/amuddu/indexnow"
    },
    "/cart": {
      en: "/cart",
      fr: "/panier",
      ar: "/عربة",
      kab: "/akessar"
    },
    "/cart/checkout": {
      en: "/cart/checkout",
      fr: "/panier/paiement",
      ar: "/عربة/الدفع",
      kab: "/akessar/adel"
    },
    "/cart/checkout/checkout-payment": {
      en: "/cart/checkout/payment",
      fr: "/panier/paiement/methode",
      ar: "/عربة/الدفع/الطريقة",
      kab: "/akessar/adel/tarikt"
    },
    "/p": {
      en: "/p",
      fr: "/p",
      ar: "/p",
      kab: "/p"
    },
    "/p/[id]": {
      en: "/p/[id]",
      fr: "/p/[id]",
      ar: "/p/[id]",
      kab: "/p/[id]"
    },
    "/privacy-policy": {
      en: "/privacy-policy",
      fr: "/politique-de-confidentialite",
      ar: "/سياسة-الخصوصية",
      kab: "/tasertit-tusligt"
    },
    "/product": {
      en: "/product",
      fr: "/produit",
      ar: "/منتج",
      kab: "/afaris"
    },
    "/product/[id]": {
      en: "/product/[id]",
      fr: "/produit/[id]",
      ar: "/منتج/[id]",
      kab: "/afaris/[id]"
    },
    "/blog/[id]": {
      en: "/blog/[id]",
      fr: "/blog/[id]",
      ar: "/مدونة/[id]",
      kab: "/blog/[id]"
    },
    "/login-signin": {
      en: "/login-signin",
      fr: "/connexion",
      ar: "/تسجيل-الدخول",
      kab: "/eqqen"
    },
    "/reset-email": {
      en: "/reset-email",
      fr: "/reinitialiser-email",
      ar: "/إعادة-تعيين-البريد",
      kab: "/beddel-email"
    },
    "/reset-password": {
      en: "/reset-password",
      fr: "/reinitialiser-mot-de-passe",
      ar: "/إعادة-تعيين-كلمة-المرور",
      kab: "/beddel-awal-ufrig"
    },
    "/terms-and-conditions": {
      en: "/terms-and-conditions",
      fr: "/conditions-generales",
      ar: "/الشروط-والأحكام",
      kab: "/tinafeltin-d-tiwtilin"
    },
    "/returns-and-refunds": {
      en: "/returns-and-refunds",
      fr: "/retours-et-remboursements",
      ar: "/الإرجاع-والاسترداد",
      kab: "/rri-tiririt"
    },
    "/help": {
      en: "/help",
      fr: "/aide",
      ar: "/مساعدة",
      kab: "/tallalt"
    },
    "/cookies-policy": {
      en: "/cookies-policy",
      fr: "/politique-de-cookies",
      ar: "/سياسة-الكوكيز",
      kab: "/tasertit-cookies"
    },
    "/charity": {
      en: "/charity",
      fr: "/charite",
      ar: "/الاعمال-الخيرية",
      kab: "/lakdira"
    },
    "/about-us": {
      en: "/about-us",
      fr: "/a-propos",
      ar: "/معلومات-عنا",
      kab: "/fella-nekni"
    },
  },
});

export type Locale = (typeof routing.locales) [number];
// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const {Link, redirect, usePathname, useRouter, getPathname} =
  createNavigation(routing);

export type AppPathname = keyof typeof routing.pathnames;
export type AppLocale = typeof routing.locales[number]; // 'en' | 'fr' | 'ar' | 'kab'